<template>
    <div v-if="dialog.isOpen" class="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50" style="z-index: 999;">
      <div class="bg-white p-6 rounded-lg shadow-lg w-96">
        <p class="text-lg font-semibold">{{ dialog.message }}</p>
        <div class="mt-4 flex justify-end space-x-2">
          <button @click="dialog.closeDialog" class="px-4 py-2 bg-gray-500 text-white rounded">Cancelar</button>
          <button @click="dialog.confirm" class="px-4 py-2 bg-red-500 text-white rounded">Confirmar</button>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import { useDialogStore } from "../shared/store/dialog";
  import { storeToRefs } from "pinia";
  
  //const dialog = storeToRefs(useDialogStore());

  const dialog = useDialogStore();
  const { isOpen, message } = storeToRefs(dialog); // Apenas os estados
  
  </script>
  